import { render, staticRenderFns } from "./ActionsNavigateCitations.vue?vue&type=template&id=66a4dbdf&scoped=true"
import script from "./ActionsNavigateCitations.vue?vue&type=script&lang=js"
export * from "./ActionsNavigateCitations.vue?vue&type=script&lang=js"
import style0 from "./ActionsNavigateCitations.vue?vue&type=style&index=0&id=66a4dbdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a4dbdf",
  null
  
)

export default component.exports